import { API_ENPOINTS } from '../../constants/api';
import { get, post, put, uploadFile } from '../../utils/requests';
import { serializeUser, deserializeUser } from './serializers';

const USER_API = API_ENPOINTS.testerManagement;

export const fetchUser = (id) => {
  const endpoint = `${USER_API}/${id}`;
  return get(endpoint).then(deserializeUser);
};

export const updateUser = (id, user) => {
  const endpoint = `${USER_API}/${id}`;
  return put(endpoint, serializeUser(user));
};

export const createUser = (user) => {
  const endpoint = `${USER_API}`;
  return post(endpoint, serializeUser(user));
};

export const uploadSignature = (id, file) => {
  const endpoint = `${USER_API}/${id}/UploadSignature`;
  return uploadFile(endpoint, file);
};

export const deleteSignature = (id) => {
  const endpoint = `${USER_API}/${id}/DeleteSignature`;
  return post(endpoint);
};

export const fetchUsers = (page, size, query) => {
  const endpoint = `${USER_API}?page=${page}&size=${size}&query=${encodeURIComponent(query)}`;
  return get(endpoint);
};

export const activateUser = (id) => {
  const endpoint = `${USER_API}/${id}/Activate`;
  return post(endpoint);
};

export const deactivateUser = (id) => {
  const endpoint = `${USER_API}/${id}/Deactivate`;
  return post(endpoint);
};

export const fetchCompanyMembers = (page = 1, size = 1000) => {
  const endpoint = `${USER_API}/CompanyMembers?page=${page}&size=${size}`;
  console.log('endpoint', endpoint);
  return get(endpoint);
};

export const validateUniqueEmail = (email) => {
  const endpoint = `${API_ENPOINTS.validate}?uniqueEmail=${email}`;
  return get(endpoint);
};

export const getCompanyMembersForAdmin = (page, size, companyId) => {
  const endpoint = `${USER_API}/CompanyMembersForAdmin?page=${page}&size=${size}&companyId=${companyId}`;
  return get(endpoint);
};

export const getEmailContacts = (query) => {
  const endpoint = `${USER_API}/MyEmailContacts?query=${query}`;
  return get(endpoint);
};

export const acceptEula = () => {
  const endpoint = API_ENPOINTS.acceptEula;
  return post(endpoint);
};

export const getAccountStatus = () => {
  const endpoint = API_ENPOINTS.accountStatus;
  return get(endpoint);
};

export const isnConnectionTest = (id, test) => {
  const endpoint = `${USER_API}/${id}/IsnConnectionTest`;
  return post(endpoint, test);
};



// WEBPACK FOOTER //
// src/actions/profile/apiRequests.js